import { PixelRatio, Dimensions } from "react-native";

export const { width, height } = Dimensions.get("window");
const scale = width / 360;

export const normalize = (size) => {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};
